import { FormEvent, useContext, useState } from "react";
import { Button, Loader } from "../Styles";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { cadastrarBacklogController } from '../../services/backlog'
import { toast } from "react-toastify";
import "./index.css"
import { useLocation } from 'react-router-dom';

function ModalBacklog() {
  const [processando, setProcessando] = useState(false);
  const { modalExibir, atualizarDados } = useContext(ModalEstadoContext)

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");

  const [titulo, setTitulo] = useState("");
  const [ideia, setIdeia] = useState("");

  const cadastrarBacklog = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    if (!idProjeto) return toast.error("Projeto não encontrado.")
    try {
      const payload = {
        titulo,
        ideia,
        idProjeto
      }
      const resposta = await cadastrarBacklogController(payload)

      if (resposta.status === 201) {
        toast.success("Backlog Cadastrado com Sucesso.")
        setTitulo("")
        setIdeia("")
        setProcessando(false)
        atualizarDados()
        modalExibir("")
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Cadastrar Backlog.")
    }
  }

  return (
    <div id='fundoModal'>
      <section className='containerModalCentro'>
        <span id='novoContainerTitulo'>
          <h1>Cadastrar Backlog</h1>
        </span>
        <form action="" className="modal-backlog-form" onSubmit={(e) => cadastrarBacklog(e)}>
          <section className="modal-backlog-content">
            <span>
              <input
                type="text"
                placeholder="Titulo da Ideia"
                className="modal-backlog-input"
                maxLength={100}
                onChange={(e) => setTitulo(e.target.value)}
              />
            </span>
            <span>
              <textarea
                name="ideia"
                className="modal-backlog-textarea"
                placeholder="Ideia de funcionalidade ou melhoria para o sistema Gesttor."
                maxLength={500}
                rows={10}
                onChange={(e) => setIdeia(e.target.value)}
              ></textarea>
            </span>
          </section>
          <span className="botoes-footer">
            <Button type="button" cor="cancelar" isLoading={processando} onClick={() => modalExibir("")}>
              Cancelar
            </Button>
            <Button type="submit" cor="salvar" isLoading={processando}>
              {!processando && "Salvar"}
              {processando && <Loader isLoading={processando} />}
            </Button>
          </span>
        </form>
      </section>
    </div>
  );
}

export default ModalBacklog;